export const members_115 = [
  {
    imgURL: "/images/members/115/member_ms_11503.jpg",
    name: {
      chinese: "周仕翔",
      english: "SHIH HSIANG CHOU",
    },
    email: "ssss9923@gmail.com",
    spec: "Unity, C#",
  },
  {
    imgURL: "/images/members/115/member_ms_11504.jpg",
    name: {
      chinese: "陳尚洋",
      english: "SHANG YANG CHEN",
    },
    email: "csyhh0423@gmail.com",
    spec: "C, Python, SystemVerilog",
  },
  {
    imgURL: "/images/members/115/member_ms_11501.jpg",
    name: {
      chinese: "江子文",
      english: "CHIANG TZU WEN",
    },
    email: "1003evan@gmail.com",
    spec: "Python, C, C++",
  },
  {
    imgURL: "/images/members/115/member_ms_11502.jpg",
    name: {
      chinese: "何基辰",
      english: "HO CHI CHEN",
    },
    email: "k60714@gmail.com",
    spec: "C++, python",
  },
  {
    imgURL: "/images/members/115/member_ms_11505.jpg",
    name: {
      chinese: "徐藝瑄",
      english: "YI HSUAN HSU",
    },
    email: "arielhsu888@gmail.com",
    spec: "C++, python",
  },
  {
    imgURL: "/images/members/115/member_ms_11506.jpg",
    name: {
      chinese: "曾予菲",
      english: "YU FEI TSENG",
    },
    email: "sophie99250@gmail.com",
    spec: "C++, Java",
  },
];
